import React from 'react';
import { Helmet } from 'react-helmet-async';
import Logo from "@/components/Logo"; // Assuming you have a Logo component

const MaintenancePage: React.FC = () => {
  return (
    <div className="flex flex-col items-center min-h-screen bg-sauna-beige text-sauna-navy p-4">
      <Helmet>
        <title>Maintenance | SaunaDip</title>
      </Helmet>
      
      <div className="mb-2">
        {/* Replace with your actual Logo component */}
        <Logo className="w-96 h-auto" />
      </div>

      <div className="text-center p-8 bg-white rounded-lg shadow-xl border-t-4 border-sauna-orange relative overflow-hidden">
        {/* Quirky background elements */}
        <div className="absolute top-0 left-0 -ml-12 -mt-12 w-32 h-32 bg-sauna-blue rounded-full opacity-20"></div>
        <div className="absolute bottom-0 right-0 -mr-12 -mb-12 w-32 h-32 bg-sauna-orange rounded-full opacity-20"></div>
        
        <h1 className="text-4xl font-bold mb-4 text-sauna-navy">Temporarily Steaming</h1>
        <p className="text-lg mb-6 text-gray-700">
          Our saunas are currently heating up (or cooling down!). We're doing some quick maintenance to improve your experience.
          We'll be back online shortly, feeling refreshed and ready to go.
        </p>
        
        <div className="flex items-center justify-center space-x-4 text-sauna-blue mb-6">
           {/* Example quirky elements - replace with icons if desired */}
           <span className="text-5xl">🔥</span>
           <span className="text-5xl">💧</span>
        </div>

        <p className="text-sm text-gray-600">
          Please check back in a few minutes.
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage; 